import Sheet from '@/components/ui/Sheet';

interface Props {
  aberto: boolean;
  modalidadeNome: string;
  encerrando: boolean;
  aoConfirmar: () => void;
  aoFechar: () => void;
}

// "Encerrar inscrições": confirma em folha do app (nunca window.confirm).
export default function FolhaEncerrar({
  aberto,
  modalidadeNome,
  encerrando,
  aoConfirmar,
  aoFechar,
}: Props) {
  return (
    <Sheet aberto={aberto} titulo="Encerrar inscrições" aoFechar={aoFechar}>
      <p className="text-[15px] leading-relaxed text-foreground-700">
        Cancela as fichas não terminadas e sobe os suplentes para as vagas que sobraram, na ordem
        da senha. Continuar?
      </p>
      {modalidadeNome && (
        <p className="mt-2 text-[14px] font-semibold text-foreground-500">{modalidadeNome}</p>
      )}
      <div className="mt-5 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={aoFechar}
          disabled={encerrando}
          className="aperta h-12 w-full cursor-pointer whitespace-nowrap rounded-[16px] border border-background-300 bg-background-50 text-[15px] font-semibold text-foreground-800 disabled:opacity-60 sm:flex-1"
        >
          Voltar
        </button>
        <button
          type="button"
          onClick={aoConfirmar}
          disabled={encerrando}
          className="aperta h-12 w-full cursor-pointer whitespace-nowrap rounded-[16px] bg-danger-500 text-[15px] font-semibold text-white disabled:opacity-60 sm:flex-1"
        >
          {encerrando ? 'Encerrando…' : 'Encerrar inscrições'}
        </button>
      </div>
    </Sheet>
  );
}